
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire70d3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire70d3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6Fatn", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $4d9eb21afff076d0$export$6503ec6e8aabbaf; }, function (v) { return $4d9eb21afff076d0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $4d9eb21afff076d0$export$f7ad0328861e2f03; }, function (v) { return $4d9eb21afff076d0$export$f7ad0328861e2f03 = v; });
var $4d9eb21afff076d0$export$6503ec6e8aabbaf;
var $4d9eb21afff076d0$export$f7ad0328861e2f03;
"use strict";
var $4d9eb21afff076d0$var$mapping = new Map();
function $4d9eb21afff076d0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$4d9eb21afff076d0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $4d9eb21afff076d0$var$resolve(id) {
    var resolved = $4d9eb21afff076d0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$4d9eb21afff076d0$export$6503ec6e8aabbaf = $4d9eb21afff076d0$var$register;
$4d9eb21afff076d0$export$f7ad0328861e2f03 = $4d9eb21afff076d0$var$resolve;

});

var $2c62fd4842d679e1$exports = {};

(parcelRequire("6Fatn")).register(new URL("", import.meta.url).toString(), JSON.parse('["hfw7y","index.79c54a96.js","cDcGl","Grocery.daa2ba7c.js"]'));


//# sourceMappingURL=index.runtime.0580be4d.js.map
